import User from './UserAdmin'

export default User
